export default __webpack_public_path__ + "static/media/cart.593b5812.svg";